// Constants
import { MaxFileUploadApiFileSize } from "@ms/uno-constants/lib/local/FileUploadConstants";
// Controls
import { TaskDetailsAttachmentsSection } from "../taskAttachments/taskDetailsSection/TaskDetailsAttachmentsSection";
// Styles
import { getCustomTaskDetailsAttachmentsSectionStyles } from "./AttachmentsSection.styles";
import { copyIconProps, deleteIconProps, editIconProps, errorIconProps, moreIconProps } from "../../../icons/icons.styles";
import { documentPreviewIconsOverrides } from "../documentPreview/DocumentPreview.styles";
// Utilities
import * as StringHelper from "@fluentui/utilities";
import * as React from "react";
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
import { useTheme } from "@fluentui/react";
/**
 * Render Attachments Section
 * @param props property of attachments section
 */ export function AttachmentsSection(props) {
    const theme = useTheme();
    const taskAttachmentRowStrings = {
        moreOptionsAriaLabel: Strings.AttachmentsSection_MoreOptionsAriaLabel,
        showOnCardAriaLabel: (attachmentAlias)=>StringHelper.format(Strings.AttachmentsSection_ShowOnCardAriaLabel, attachmentAlias),
        showOnCardLabel: Strings.AttachmentsSection_ShowOnCardLabel,
        openInNewWindowMenuOption: Strings.AttachmentsSection_OpenInNewWindowMenuOption,
        editMenuOption: Strings.AttachmentsSection_EditOption,
        removeMenuOption: Strings.AttachmentsSection_RemoveOption,
        invalidLinkError: Strings.AttachmentsSection_InvalidLinkError,
        copyLinkOption: "",
        actionButtonLabel: ""
    };
    const attachmentSectionStrings = {
        taskAttachmentsLabel: Strings.AttachmentsSection_AttachmentsLabel,
        fileTooBigErrorMessage: StringHelper.format(Strings.AttachmentsSection_FileTooBigErrorMessage, MaxFileUploadApiFileSize / 1000000),
        maximumTaskAttachmentsAddedHoverText: Strings.AttachmentsSection_MaximumAttachmentsAdded,
        noEditPermissionHoverText: Strings.AttachmentsSection_NoEditPermissions,
        addTaskAttachmentButtonText: Strings.AttachmentsSection_AddAttachmentButtonText,
        addTaskAttachmentMenuOptionTextFileUpload: Strings.AttachmentsSection_BrowseComputerMenuOption,
        addTaskAttachmentMenuOptionTextSharePoint: Strings.AttachmentsSection_BrowseTeamSharePointMenuOption,
        addTaskAttachmentMenuOptionTextLink: Strings.AttachmentsSection_LinkMenuOption,
        addTaskAttachmentMenuOptionFileUploadDisabledTooltip: Strings.AttachmentsSection_FileUploadDisabledTooltip,
        addTaskAttachmentMenuOptionSharePointDisabledTooltip: Strings.AttachmentsSection_BrowseSharePointDisabledTooltip,
        taskAttachmentRowStrings: taskAttachmentRowStrings,
        collapsibleSectionHideAriaLabel: "",
        collapsibleSectionShowAriaLabel: ""
    };
    const customStyles = getCustomTaskDetailsAttachmentsSectionStyles(theme, props.styles);
    const taskAttachmentRowIcons = {
        alert: errorIconProps,
        remove: deleteIconProps,
        edit: editIconProps,
        more: moreIconProps,
        copy: copyIconProps
    };
    return /*#__PURE__*/ React.createElement(TaskDetailsAttachmentsSection, {
        callbacks: props.attachmentSectionCallbacks,
        config: props.attachmentSectionConfig,
        taskAttachmentSectionStrings: attachmentSectionStrings,
        taskAttachmentRowItems: props.attachmentRowItems,
        maximumAttachmentsPerTask: props.maximumAttachmentsPerTask,
        maximumSizeForTaskAttachment: MaxFileUploadApiFileSize,
        taskAttachmentToEdit: props.attachmentToEdit,
        renderCollapsibleAttachments: false,
        styles: customStyles,
        taskAttachmentRowIcons: taskAttachmentRowIcons,
        documentPreviewIcons: documentPreviewIconsOverrides,
        enableExternalUrlRegexCheck: props.enableExternalUrlRegexCheck
    });
}
